<template>
  <v-container fluid class="szerzok hirlista-oldal">
    <div :class="{ 'page-content': !isMobile }">
      <v-btn
        icon
        large
        color="primary"
        class="back-btn"
        @click="$goBackTo({ name: 'Fooldal' })"
      >
        <i class="fas fa-chevron-left"></i>
      </v-btn>
      <h2>Szerzők</h2>
      <v-tabs
        show-arrows
        next-icon="fas fa-angle-right"
        prev-icon="fas fa-angle-left"
        v-model="tab"
        class="mt-2"
      >
        <v-tabs-slider color="primary"></v-tabs-slider>

        <v-tab v-for="szerzo in szerzokSorrendezve" :key="szerzo.Id">
          {{ szerzo.Nev }}
        </v-tab>
      </v-tabs>
      <v-tabs-items
        :touchless="true"
        :next-icon="false"
        :prev-icon="false"
        v-model="tab"
      >
        <v-tab-item v-for="szerzo in szerzokSorrendezve" :key="szerzo.Id">
          <k-hir-lista :getHirek="GetHirek(szerzo.Id)"></k-hir-lista>
        </v-tab-item>
      </v-tabs-items>
    </div>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { AppFunctions } from '../functions/AppFunctions';
import { hirService } from '../services/HirService';
import { AppStoreTypes } from '../store/modules/app';

export default {
  name: 'Szerzok',
  data() {
    return {
      tab: null,
    };
  },
  mounted() {},
  created() {},
  methods: {
    GetHirek(szerzoId) {
      return utolsoHir => {
        return hirService.GetHirekSzerzokhoz({
          szerzoId: szerzoId,
          utolsoHirId: utolsoHir?.Id,
        });
      };
    },
  },
  computed: {
    ...mapGetters({
      fooldalData: AppStoreTypes.fooldalData.get,
      user: AppStoreTypes.user.get,
    }),
    tabUpdate() {
      return [this.szerzokSorrendezve.length, this.routeSzerzoId].join('_');
    },
    szerzokSorrendezve() {
      return AppFunctions.SortSzerzok(this.fooldalData.aktivSzerzok, this.user);
    },
    routeSzerzoId() {
      return this.$route.params.id;
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  watch: {
    tabUpdate: {
      handler(v) {
        let routeSzerzoId = this.routeSzerzoId;
        let idx = this.szerzokSorrendezve.findIndex(f => f.Id == routeSzerzoId);
        if (idx) {
          this.tab = idx;
        }
      },
      immediate: true,
    },
  },
  components: {},
};
</script>
